<template>
  <div class="tencent-map-picker">
    <el-input
      :value="value"
      readonly
      :placeholder="placeholder"
      class="map-input"
      @click.native="open"
    >
      <el-button slot="append" icon="el-icon-location">地图选点</el-button>
    </el-input>
    <el-dialog
      title="地图选点"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      destroy-on-close
      :close-on-click-modal="false"
      @close="dialogClose"
    >
      <div class="dialog_map">
        <iframe
          v-if="dialogVisible"
          name="mapFrame"
          :src="mapOption"
          style="width: 100%; height: 600px; border: none;"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const KEY = "DVKBZ-BFS3Z-LSBX3-7NBLG-DM7Q7-QQFOZ";
const GEOCODER_URL = "https://apis.map.qq.com/ws/geocoder/v1/";

export default {
  name: "TencentMapPicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请点击右侧按钮在地图上选点",
    },
    mapKey: {
      type: String,
      default: () => KEY,
    },
  },
  data() {
    return {
      dialogVisible: false,
      mapOption: `https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=${KEY}&referer=myapp&total=10`,
      mapInfo: {
        address: "",
        lat: "",
        lon: "",
      },
    };
  },
  watch: {
    mapKey: {
      immediate: true,
      handler(val) {
        const key = val || KEY;
        this.mapOption = `https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=${key}&referer=myapp&total=10`;
      },
    },
  },
  mounted() {
    window.addEventListener("message", this.handleMapMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMapMessage);
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    dialogClose() {
      this.dialogVisible = false;
      this.mapInfo = { address: "", lat: "", lon: "" };
    },
    dialogConfirm() {
      if (!this.mapInfo.address) {
        this.$message.warning("请选择位置");
        return;
      }
      const payload = { ...this.mapInfo };
      this.$emit("input", payload.address);
      this.$emit("change", payload.address);
      this.$emit("confirmMap", payload);
      this.dialogClose();
    },
    async handleMapMessage(event) {
      const loc = event.data;
      if (!loc || loc.module !== "locationPicker") return;

      let addressName = "";
      if (loc.poiname === "我的位置") {
        try {
          const res = await fetch(
            `${GEOCODER_URL}?location=${loc.latlng.lat},${loc.latlng.lng}&key=${this.mapKey || KEY}`
          ).then((r) => r.json());
          addressName = (res.result && res.result.formatted_addresses && res.result.formatted_addresses.recommend) || "";
        } catch (e) {
          addressName = "";
        }
      } else {
        addressName = loc.poiname || "";
      }

      this.mapInfo = {
        address: addressName,
        lat: String(loc.latlng.lat),
        lon: String(loc.latlng.lng),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tencent-map-picker {
  width: 100%;
}
.map-input {
  width: 100%;
  ::v-deep .el-input-group__append {
    padding: 0;
    .el-button {
      margin: 0;
      border-radius: 0 4px 4px 0;
    }
  }
}
.dialog_map {
  width: 100%;
}
</style>
